<script>
  import Page from '@components/page.svelte'
  import Tag from '@components/general/tag.svelte'
  import TagForm from '@components/tags/form.svelte'
  import Button from '@components/buttons/button.svelte'
  import { CirclePlus } from 'lucide-svelte'

  let { tags = [] } = $props()

  let selectedTag = $state(null)
  let showTagForm = $state(false)
  
  function selectTag(tag) {
    selectedTag = tag
    showTagForm = true
  }

  function newTag() {
    selectedTag = null
    showTagForm = true
  }

  function closeTagForm() {
    selectedTag = null
    showTagForm = false
  }

</script>

<Page title="Tags" subtitle="Manage your tags" links={[{ text: "Admin", href: "/admin" }]}>

  {#snippet buttons()}
    <Button text="New tag" Icon={CirclePlus} iconProps={{ size: 12 }} onclick={newTag} />
  {/snippet}

  <div class="flex items-center gap-2 flex-wrap max-w-[80ch]">
    {#each tags as tag (tag.id)}
      <Tag {tag} size="md" onSelect={() => selectTag(tag)} />
    {/each}
  </div>
  
</Page>

<TagForm tag={selectedTag} bind:open={showTagForm} onClose={closeTagForm} />
